<template>
  <div class="auth-container">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="username">Username:</label>
        <input type="text" id="username" v-model="username" required>
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="password" required>
      </div>
      <button type="submit">Login</button>
    </form>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2'; // <-- Impor SweetAlert2 di sini

export default {
  data() {
    return {
      username: '',
      password: '',
      error: null, // Properti error tetap ada untuk menyimpan pesan, tapi tidak lagi ditampilkan di template
    };
  },
  methods: {
    async login() {
      try {
        this.error = null;
        const response = await axios.post('https://api.pala.linksoftindo.com/api/auth/login', {
          username: this.username,
          password: this.password,
        });
        console.log(response.data);
        localStorage.setItem('token', response.data.token); // Simpan token
        localStorage.setItem('user', JSON.stringify(response.data.user)); // Simpan user data

        // Ganti alert() dengan SweetAlert2 untuk notifikasi sukses
        await Swal.fire({
          icon: 'success',
          title: 'Login Berhasil!',
          text: 'Selamat datang kembali.',
          timer: 1500, // Notifikasi akan hilang setelah 1.5 detik
          showConfirmButton: false // Tidak perlu tombol "OK"
        });

        this.$router.push('/income'); // Redirect ke halaman pemasukan
      } catch (err) {
        // Tangani error dari API
        this.error = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : 'Terjadi kesalahan saat login.';
        console.error('Error login:', err);

        // Ganti tampilan error langsung dengan SweetAlert2
        Swal.fire({
          icon: 'error',
          title: 'Login Gagal!',
          text: this.error,
          confirmButtonText: 'Coba Lagi'
        });
      }
    },
  },
};
</script>

<style scoped>
.auth-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  text-align: center;
}

.auth-container h2 {
  margin-bottom: 25px;
  color: #333;
}

.form-group {
  margin-bottom: 18px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 7px;
  font-weight: bold;
  color: #555;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box; /* Agar padding tidak menambah lebar */
  font-size: 16px;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 17px;
  font-weight: bold;
  margin-top: 15px;
  transition: background-color 0.2s ease;
}

button:hover {
  background-color: #0056b3;
}

.error-message {
  color: #dc3545;
  margin-top: 15px;
  font-size: 0.9em;
}

p {
  margin-top: 20px;
  font-size: 0.9em;
  color: #666;
}

p a {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

p a:hover {
  text-decoration: underline;
}
</style>